import { v1 as uuid } from 'uuid';

// we are not using reducers because they are mounted/unmounted in random cases
// and we need to maintain the same id for the same tab
export const getTabId = () => {
  let value = window.sessionStorage.getItem('current-tab-id');
  if (!value) {
    value = uuid();
    window.sessionStorage.setItem('current-tab-id', value);
  }

  return value;
};
